import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    gap: 24px;
    margin-bottom: 24px;
    width: 100%;
  `};
`;

export const Image = styled.img`
  height: 100%;
  max-width: 300px;
  width: 100%;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    max-width: 520px;
    text-align: center;
  `};
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    margin: 0;
    max-width: 520px;
    text-align: center;
  `};
`;
